(function (ws) {
    'use strict';
    ws.models.fraudulentModel = Backbone.Model.extend({
        /**
         * the url root
         */
        urlRoot: function() {
            if (isQuotingSite) {
                return globals.path.api.quoting.fraudulentUrl;
            } else if (isOrderEntrySite) {
                return globals.path.api.orderentry.fraudulentUrl.replace('{orderNumber}', this.get('orderNumber'));
            }
        }
    });
})(westcon);
